import { render, staticRenderFns } from "./InformarProdutosPedido.vue?vue&type=template&id=0125d85a&"
import script from "./InformarProdutosPedido.vue?vue&type=script&lang=js&"
export * from "./InformarProdutosPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports